import t from 'react-translate';
import { css } from '@emotion/react';
import { halfSpacing } from 'styles/global_defaults/scaffolding';
import { lowTide } from 'styles/global_defaults/colors';

const styles = css`
  border: 1px solid ${lowTide};
  border-radius: ${halfSpacing}px;
`;

const CompleteStatus = () => (
  <div css={styles} className='d-flex py-2 px-4 flex-column'>
    <div>
      <p className='text-regular font-weight-bolder mb-0 text-gray-1'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.GOOD_JOB_FINISHING()}</p>
    </div>
    <div>
      <p className='text-regular mb-0 text-gray-2'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.LOOK_ON_FEEDBACK()}</p>
    </div>
  </div>
);

export default CompleteStatus;
